import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, tone = "jade" }) => (
  <span
    className={`flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.28em] ${
      tone === "jade" ? "text-jade" : "text-ivory/60"
    }`}
  >
    <span
      className={`h-px w-8 ${tone === "jade" ? "bg-jade" : "bg-ivory/40"}`}
      aria-hidden="true"
    />
    {children}
  </span>
);
